'use es6';

import PropTypes from 'prop-types';
import { Map as ImmutableMap } from 'immutable';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { isStandaloneReport } from 'reporting-action-components/lib/report-logic';
import { jsx as _jsx } from "react/jsx-runtime";
const AssignedCell = ({
  report
}) => {
  return /*#__PURE__*/_jsx("td", {
    children: isStandaloneReport(report) ? /*#__PURE__*/_jsx(FormattedMessage, {
      message: `reports.subHeader.assigned.options.${report.get('accessClassification')}`
    }) : '--'
  });
};
AssignedCell.propTypes = {
  report: PropTypes.instanceOf(ImmutableMap).isRequired
};
export default AssignedCell;